import { render, staticRenderFns } from "./MemberClassesPeriod.vue?vue&type=template&id=5fde3350&scoped=true&"
import script from "./MemberClassesPeriod.vue?vue&type=script&lang=js&"
export * from "./MemberClassesPeriod.vue?vue&type=script&lang=js&"
import style0 from "./MemberClassesPeriod.vue?vue&type=style&index=0&id=5fde3350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde3350",
  null
  
)

export default component.exports